<template>
    <div class="col-lg-6 col-md-6 col-12 " id="personal_information_step">
        <div class="card">
            <div class="collapse-margin collapse-icon " id="reports-collapser">
            <div class="card-header" id="paymentOne1" data-toggle="collapse" role="button" data-target="#reports-collapse" aria-expanded="true"
                aria-controls="reports-collapse">
                <div class="lead collapse-title">
                    <div class="media">
                        <div class="media-body">
                            <div class="row mx-auto">
                                    <div v-if="userStore.userDashboard.user_info_status == 'Complete'">
                                        <h3 class="mb-1 font-small-4 text-primary">
                                            Update Your Personal Identifier Info
                                        </h3>
                                    </div>
                                    <div v-else>
                                        <p>
                                            <span class="badge badge-primary badge-glow mr-1">Step 1: </span>
                                            <span class="mb-1 font-small-4 text-primary">Enter Your Personal Identifier Info</span>
                                        </p>
                                    </div>
                            </div>
                            <div class="design-group">
                                <h6 class="section-label">Enter Personal Info:</h6>
                                <div class="badge badge-glow badge-success" v-if="userStore.userDashboard.user_info_status == 'Complete'">
                                        {{ userStore.userDashboard.user_info_status }} <i data-feather="check-circle"></i>
                                </div>
                                <div class="badge badge-glow badge-warning  badge-sm mr-0 mb-0" v-else>
                                    {{ userStore.userDashboard.user_info_status }} <i data-feather="x-circle"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="reports-collapse" class="collapse show" aria-labelledby="paymentOne1" data-parent="#reports-collapser">
                <hr>
                <div class="card-body">
                    <div class="">
                        <p class="card-text font-small-4">
                            First thing first is for you to enter your <strong>Personal Information</strong>.
                            <br /><br />
                            Once you've entered your <strong>Personal Information</strong> your disputes will be auto-populated with this information.<br>
                        </p>
                        <hr>
                    </div>
                    <div class="d-flex justify-content-center">
                        <a href="#" class="btn btn-sm btn-primary mr-1 waves-effect waves-light d-flex" data-toggle="modal" data-target="#personal_info_modal_update">
                            <span class="d-flex" v-if="userStore.userDashboard.user_info_status == 'Complete'">
                                <vue-feather type="edit" size="18"></vue-feather>
                                <span style="
                                    margin-top: 4px;
                                    padding-left: 5px;
                                "> Update </span>
                            </span>
                            <span class="d-flex" v-else>
                                <vue-feather type="edit" size="18"></vue-feather>
                                <span style="
                                    margin-top: 4px;
                                    padding-left: 5px;
                                "> Enter Personal Info </span>
                            </span>
                        </a>
                        <a href="#" data-toggle="modal" data-target="#personal_info_modal_video" class="btn btn-sm btn-outline-primary waves-effect d-flex">
                            <vue-feather type="film" size="18"></vue-feather>
                            <span style="
                                margin-top: 2px;
                                padding-left: 5px;
                            "> Tutorial</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {ref} from 'vue'
import { useUserStore } from '../../../stores/UserStore.js'
import PersonalInfoModal from './PersonalInfo/PersonalInfoModal.vue'
export default{
    components:{
        PersonalInfoModal
    },
    setup(){
        return {
            userStore:useUserStore()
        }
    },
    methods:{
        checkCollapsed(){
            if(this.updateCollapse.classList.contains('collapsed')){
                this.userStore.collapsed = false
                this.userStore.leftCollapse = false
            }else{
                this.userStore.collapsed = true
                this.userStore.leftCollapse = true
            }
        }
    }
}
</script>
